import styles from "./styles.module.scss";
import { NearbyStoreItem } from "@/components/NearbyStoreItem";
import { StoreListItem } from "@/types/filters";
import { Distance } from "@/utils/geoLocation";
import { ComponentInfosLojaAddressInput } from "@/graphql/generated/graphql";
import CarouselMulti from "@/components/shared/CarouselMulti";

export interface NearbyStoresProps {
  stores: StoreListItem[];
  address: ComponentInfosLojaAddressInput;
}

const NearbyStores = ({ stores, address }: NearbyStoresProps) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1025 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1040, min: 870 },
      items: 2.5
    },
    xtablet: {
      breakpoint: { max: 869, min: 740 },
      items: 2.2
    },
    mobile: {
      breakpoint: { max: 739, min: 520 },
      items: 1.5
    },
    xmobile: {
      breakpoint: { max: 671, min: 421 },
      items: 1.2
    },
    xxmobile: {
      breakpoint: { max: 420, min: 0 },
      items: 1.1
    }
  };

  // Ordenando as lojas por distância para corrigir qualquer desordem
  const storesOrdered = stores.sort(
    (a, b) =>
      Distance(address.long, address.lat, a.address.long, a.address.lat) -
      Distance(address.long, address.lat, b.address.long, b.address.lat)
  );

  return (
    <div className={styles.wrapper}>
      <CarouselMulti responsiveCustom={responsive} removeArrowOnDeviceType={[]}>
        {storesOrdered.map((item, index) => (
          <NearbyStoreItem
            key={index}
            item={item as StoreListItem}
            index={index}
            distance={Distance(
              address.long,
              address.lat,
              item.address.long,
              item.address.lat
            )}
          />
        ))}
      </CarouselMulti>
    </div>
  );
};

export default NearbyStores;
